import React from 'react';
import { Typography, Button, Chip, Box, Avatar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CallMadeIcon from '@mui/icons-material/CallMade';
import { CallReceivedRounded } from '@mui/icons-material';
import { ButtonSx, ChipSx } from '../styles/GlobalStyles';

const CallCard = ({ data, url }) => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
            borderRadius: '1.5rem',
            border: '1px solid #E5E7EB',
            backgroundColor: '#fff',
            p: '1.5rem',
            width:'100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            height: '100%',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            '&:hover': {
                transform: 'scale(1.01)',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)',

            },
            }}
        >
            <Box style={{ height: "150px", display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "0", width:'100%' }}>
                <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: "0.2rem", overflow: "hidden" }}>                    
                        <Typography 
                            variant="h6"
                            noWrap
                            sx={{
                                color: "#343434",
                                fontSize: "1rem",
                                fontWeight: 600,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%",
                            }}
                            >
                            {data.Label || "No Label"}
                        </Typography>
                        <Typography
                            variant="body2"
                            noWrap
                            sx={{
                                color: "#555",
                                fontSize: "0.875rem",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%",
                            }}
                            >
                            {data.PhoneNumber}
                        </Typography>
                    
                        {/*Chips for Outbound and Inbound Assistant*/}
                        <Box sx={{ display: "flex", gap: "0.5rem", mt: "0.5rem" }}>
                            <Chip
                                avatar={
                                    <Avatar
                                        alt={data.OutboundAssistantId?.Name || "NA"}
                                        src={data.OutboundAssistantId?.Logo?.fileUrl}
                                        sx={{ width: 16, height: 16 }} // Adjust the size here
                                    />
                                }
                                label={(data.OutboundAssistantId?.Name ?? "").length > 10 ? `${(data.OutboundAssistantId?.Name ?? "").slice(0, 10)}..` : data.OutboundAssistantId?.Name || "NA"}
                                deleteIcon={<CallMadeIcon sx={{ color: "#02042D" }} />}
                                size="small"
                                onDelete={() => {}}
                                sx={ChipSx}
                            />
                            <Chip
                                avatar={
                                    <Avatar
                                        alt={data.InboundAssistantId?.Name || "NA"}
                                        src={data.InboundAssistantId?.Logo?.fileUrl}
                                        sx={{ width: 16, height: 16 }} // Adjust the size here
                                    />
                                }
                                label={(data.InboundAssistantId?.Name || "").length > 10 ? `${(data.InboundAssistantId?.Name || "").slice(0, 10)}..` : data.InboundAssistantId?.Name || "NA"}
                                size="small"
                                deleteIcon={<CallReceivedRounded sx={{ color: "#02042D" }} />}
                                onDelete={() => {}}
                                sx={ChipSx}
                            />
                        </Box>
                </Box>
                <Button variant="contained" sx={ButtonSx} key={data.id} onClick={() => navigate(url)}>
                    View Details
                </Button>
            </Box>
        </Box >
    );
};



export default CallCard;